export const PlanStatus = {
    Draft: {
        id: 1,
        key: 'Draft',
        label: 'Draft',
        //icon: 'Draft'
    },
    Pending: {
        id: 2,
        key: 'Pending',
        label: 'Plan Generation',
        //icon: 'Draft'
    },
    Submitted: {
        id: 3,
        key: 'Submitted',
        label: 'Plan Generation',
        //icon: 'Draft'
    },
    PreviewReady: {
        id: 4,
        key: 'PreviewReady',
        label: 'Media Plan Ready',
        //icon: 'Draft'
    },
    Error: {
        id: 5,
        key: 'Error',
        label: 'Error',
        //icon: 'Draft'
    },
    Activated: {
        id: 6,
        key: 'Activated',
        label: 'Sent',
        //icon: 'Draft'
    },
    Archived: {
        id: 7,
        key: 'Archived',
        label: 'Archived',
        //icon: 'Draft'
    },
    PaasError: {
        id: 8,
        key: 'PaasError',
        label: 'Media Plan Failed',
        //icon: 'Draft'
    },
    DspError: {
        id: 9,
        key: 'DspError',
        label: 'Send to Campaigns Failed',
        //icon: 'Draft'
    },
    Expired: {
        id: 10,
        key: 'Expired',
        label: 'Plan Expired',
        //icon: 'Draft'
    }
};